import React from "react";

const CrmInputField = ({ label, type = "text", value, onChange, name }) => {
    return (
        <div className="flex flex-col">
            <label className="block text-[14px] font-semibold uppercase text-gray-700">
                {label}</label>
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                className="w-full border p-2 rounded-lg focus:ring-2 focus:ring-[#4DA896] focus:border-[#5a4fbe00]"
            />
        </div>
    );
};

export default CrmInputField;
